import React, { memo, ReactElement } from "react";
import { Control, Controller, EventFunction } from "react-hook-form";
import { PropTypes } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { ErrorLabel } from "../index.css";

interface IProps<T> {
  control: Control;
  format: string;
  margin: PropTypes.Margin;
  name: string;
  label: string;
  disabled?: boolean;
  onChange: any;
  required?: boolean;
  rules?: Record<string, boolean>;
  errors: any;
  value: T;
  minDate?: Date;
}

const KeyboardDatepickerInput = (props: IProps<any>): ReactElement => {
  const { onChange, control, name, label, disabled, required, errors, format, margin, minDate, value } = props;
  const handleChange: EventFunction = ([date]) => {
    onChange(date);
    return date;
  };
  const validateDate = (date: unknown) =>
    date == null || (date instanceof Date && !Number.isNaN(date.getTime()));

  return (
    <>
      <Controller
        as={
          <KeyboardDatePicker
            style={{ width: "100%" }}
            onChange={() => undefined}
            value={null}
            required={required}
            format={format}
            margin={margin}
            minDate={minDate}
          />
        }
        control={control}
        onChange={handleChange}
        name={name}
        label={label}
        disabled={disabled}
        rules={{ required, validate: validateDate }}
        defaultValue={value}
      />
      <ErrorLabel>
        {errors[name] && (errors[name].type === "validate" ? "Enter a valid date" : "This field is required")}
      </ErrorLabel>
    </>
  );
};

export default memo(KeyboardDatepickerInput);
